<app-card>
  <app-analytics-card-info>
    <div i18n title>Visitors</div>
    <div i18n info>
      A visitor is counted when entering InnovationHub from a URL different from InnovationHub. No cookies or similar
      tracking methods are used. This means if the same user visits InnovationHub again from another URL, it will count
      as two separate visitors.
    </div>
    <div subtitle>{{ period() }}</div>
  </app-analytics-card-info>
  <div class="analytics">
    <div class="countries">
      <div class="info-box">
        <h2 i18n>Total visitors in the period:</h2>
        <p class="number">{{ totalVisitors() }}</p>
      </div>
      <app-graph-geo [visitors]="data()?.byCountry"></app-graph-geo>
      <app-table [data]="visitorsByCountryTable().data" [labels]="visitorsByCountryTable().labels"></app-table>
    </div>
    <div class="visitors">
      <app-visitors-graph [visitors]="data()?.byDate"></app-visitors-graph>
      <app-table [data]="visitorsByDateTable().data" [labels]="visitorsByDateTable().labels"></app-table>
    </div>
    <div class="info">
      <span i18n>More details in</span> <app-link i18n [href]="analyticsLink">Simple Analytics</app-link>
      <span i18n>(separate login required)</span>
    </div>
  </div>
</app-card>
